var map = {
	"./ancap-1-.svg": 3678,
	"./ancap-2.svg": 3679,
	"./ancap-3.svg": 3680,
	"./ancap-4.svg": 3681,
	"./ancap-5.svg": 3682
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3824;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/ancap\-.*\.svg$
// module id = 3824
// module chunks = 4